import Model from './Model';

export default class ServiceTime extends Model {
  resource() {
    return 'service-times';
  }
}
